// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-update-cloud-storage-form-wrapper{text-align:center;padding-top:40px;overflow-y:auto;height:90%;position:fixed;width:100%}.cvat-update-cloud-storage-form-wrapper>div>span{font-size:32px}", ""]);
// Exports
module.exports = exports;
